// Content of the North OS Meetings demo. Everything is invented: no real person, project, address, lender
// or investor. Only the public vocabulary of affordable-housing real estate practice is real.

export type MeetingStatus = "ready" | "transcribing";

export type Meeting = {
  id: string;
  title: string;
  matter: string;
  meta: string[];
  summary: string;
  people: string[];
};

/** The call the demo records: absent from the poster, first in the list once it lands. */
export const NEW_MEETING: Meeting = {
  id: "cedar-lender-call",
  title: "Construction loan closing — lender call",
  matter: "Cedar Court · 148 units · Bronx",
  meta: ["ZOOM", "TODAY", "9:30AM", "5 ATTENDEES", "41MIN"],
  summary: "Checklist signed off. Title rundown and architect's certificate still gate the Sept 30 closing.",
  people: ["MR", "JL", "AK"],
};

/** Already processed meetings, newest first. */
export const PAST_MEETINGS: Meeting[] = [
  {
    id: "linden-loi",
    title: "LIHTC syndication — investor LOI redlines",
    matter: "Linden Terrace · 96 units · Brooklyn",
    meta: ["GOOGLE MEET", "SEP 16", "3:15PM", "4 ATTENDEES", "52MIN"],
    summary: "Investor pushed back on the capital contribution schedule. Revised LOI due Monday.",
    people: ["DS", "MR"],
  },
  {
    id: "harbor-regulatory",
    title: "HPD regulatory agreement — rent-up schedule",
    matter: "Harbor View Senior · 120 units · Queens",
    meta: ["TEAMS", "SEP 16", "11:00AM", "6 ATTENDEES", "33MIN"],
    summary: "HPD accepts a phased rent-up. Marketing plan to be filed before TCO.",
    people: ["JL", "EP", "TK"],
  },
  {
    id: "cedar-title",
    title: "Title objections — Schedule B review",
    matter: "Cedar Court · 148 units · Bronx",
    meta: ["PHONE", "SEP 15", "4:40PM", "2 ATTENDEES", "18MIN"],
    summary: "Three exceptions left to clear. Surveyor to update the easement map.",
    people: ["MR", "AK"],
  },
  {
    id: "maple-conversion",
    title: "Permanent loan conversion — checklist",
    matter: "Maple Commons · 210 units · Bronx",
    meta: ["ZOOM", "SEP 15", "1:00PM", "5 ATTENDEES", "45MIN"],
    summary: "Conversion slips two weeks pending final 8609s.",
    people: ["EP", "DS", "JL"],
  },
  {
    id: "closings-standup",
    title: "Weekly closings stand-up",
    matter: "Real estate group",
    meta: ["IN PERSON", "SEP 15", "8:42AM", "7 ATTENDEES", "24MIN"],
    summary: "Four closings this month. Cedar Court is on the critical path.",
    people: ["TK", "MR", "JL"],
  },
];

/** Recording prompt: the call in progress is the new meeting. */
export const PROMPT_META = ["ZOOM", "TODAY", "5 ATTENDEES"];

/** Recording timer, fast-forwarded to the call's 41 minutes while the demo records. */
export const TIMER_STEPS = ["00:00", "00:01", "00:02", "03:48", "11:05", "19:32", "27:14", "34:51", "41:06"];

/** Detail panel of the new meeting. The TL;DR is written sentence by sentence. */
export const TLDR = [
  "HDC and the senior lender signed off on the closing checklist.",
  "Two items still gate the Sept 30 closing: the updated title rundown and the architect's certificate.",
  "HPD returns its regulatory agreement comments Thursday.",
];

export const TLDR_SOURCE = "GENERATED BY NORTH · CITES 3 SOURCES";

export type ActionItem = { text: string; owner: string; due: string };

export const ACTION_ITEMS: ActionItem[] = [
  { text: "Order the updated title rundown and bring-down", owner: "MR", due: "WED" },
  { text: "Get the architect's certificate signed", owner: "JL", due: "THU" },
  { text: "Send HPD's comments to lender's counsel", owner: "YOU", due: "FRI" },
];
